import type { IUsageResponse } from '@escloud/types';

import type { ApiClient } from './api-client';

export class UsageService {
    constructor(private api: ApiClient) {}

    getUsage(tenantId: string): Promise<IUsageResponse> {
        return this.api.get<IUsageResponse>(`/tenants/${tenantId}/usage`);
    }
}
